import { AdminBreadcrumb } from '../../components/AdminBreadcrumb';

export function TemplateBreadCrumb() {
  return (
    <AdminBreadcrumb items={[{ label: 'Applications', isCurrentPage: true }]} />
  );
}
